import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { Grid } from '@mui/system';
import { FORMS_TYPES } from 'common/types';
import CustomTextField from 'components/CustomTextField';
import { AccessLevelSelect, AccessLevelValue } from 'components/ui/AccessLevelSelect';
import { useFormValidation } from 'services/hooks/useFormValidation';
import { CONSTRAINTS } from './constants';
import { FormValueProFormaCapTable, ProformaCapTableFormProps } from './ProformaCapTableForm.props';

const ProformaCapTableForm = ({ initialValues, onFormChange, tableTerms }: ProformaCapTableFormProps) => {
  const { formValidated, validateForm } = useFormValidation(CONSTRAINTS);
  const [formValues, setFormValues] = useState<FormValueProFormaCapTable>(initialValues);
  const { errors } = formValidated;

  useEffect(() => {
    validateForm(formValues);
  }, [validateForm, formValues]);

  // Save must use the visible fields, not an earlier queued valid form snapshot.
  useEffect(() => {
    onFormChange(formValidated);
  }, [onFormChange, formValidated]);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleAccessLevelChange = useCallback((value: AccessLevelValue) => {
    setFormValues(prev => ({
      ...prev,
      access_level: value,
    }));
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <CustomTextField
          required
          fullWidth
          id="name"
          name="name"
          type="text"
          label={`${tableTerms.tableName} name`}
          value={(formValues.name as string) ?? ''}
          onChange={handleChange}
          formErrors={errors as FORMS_TYPES.FormFieldErrors}
        />
      </Grid>
      <Grid size={12}>
        <Typography gutterBottom sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
          Access Options
        </Typography>
        <AccessLevelSelect
          value={(formValues.access_level as AccessLevelValue) ?? 'restricted'}
          onChange={handleAccessLevelChange}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default ProformaCapTableForm;
